import * as React from 'react';
import { SVGProps } from 'react';

const IconVideoSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V9l3 2V5l-3 2V5a1 1 0 0 0-1-1H3z" />
  </svg>
);
export default IconVideoSizeS;
